import { observable, action, computed } from "mobx";
import { computedFn } from "mobx-utils";

export class LoadingStore {
  @observable private activePromises: { name: string; promise: Promise<unknown> }[] = [];

  @action.bound async track<T>(promiseAction: () => Promise<T>, name?: string) {
    if (!name) name = new Date().toISOString();
    const promise = promiseAction().finally(() => {
      const indexToRemove = this.activePromises.findIndex(p => p.name === name);
      if (indexToRemove === -1) {
        console.error("Cannot remove promise from active promises");
        return;
      }

      this.activePromises.splice(indexToRemove, 1);
    });

    this.activePromises.push({ name, promise });
    return await promise;
  }

  @computed get isComplete() {
    return this.activePromises.length === 0;
  }

  @computed get isBusy() {
    return this.activePromises.length > 0;
  }

  isInProgress = computedFn((actionNames: string | string[]) => {
    if (typeof actionNames === "string") actionNames = [actionNames];
    return actionNames.some(actionName => this.activePromises.some(p => p.name === actionName));
  }, true);
}
